module.exports = __webpack_public_path__ + "static/media/ProductSansRegular.eae9c18c.ttf";